<script module lang="ts">
  import type { Snippet } from 'svelte';
  import { type AllowedAlign } from './button.types';

  export interface Props {
    align?: AllowedAlign;
    children?: Snippet;
  }
</script>

<script lang="ts">
  import { allowedAligns } from './button.types';

  const { align, children }: Props = $props();

  // -
  const DefaultAlign = allowedAligns[0];
  const Align = $derived(align && allowedAligns.includes(align) ? align : DefaultAlign);
</script>

<div class="buttonLine {Align === 'left' ? 'alignLeft' : ''}">
  {@render children?.()}
</div>

<style lang="scss">
  @use '../../../styles/display';

  .buttonLine {
    @include display.block;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: center;
    gap: var(--outset-abs-half);
    margin-top: var(--outset-abs);

    &.alignLeft {
      justify-content: flex-start;
    }
  }
</style>
